import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  tabs: {
    borderBottom: [1, 'solid', theme.palette.colors.border],
  },
  tab: {
    marginRight: theme.spacing(3),
    '&:first-child': {
      marginLeft: theme.spacing(3),
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerRealEstateAgents/components/Tabs/useStyles.js